import ajax from '../utils/request'

const channelApi = {
  /***************************渠道查询****************************** */
  // 请求渠道查询,日志（同一个）列表列表
  getChannelLogList(params) {
    return ajax({
      url: '/channel/channelLog/list',
      type: 'get',
      params: params
    })
  },
  // 修改渠道日志
  updateChannelLog(params) {
    return ajax({
      url: '/channel/channelLog/update',
      type: 'post',
      params: params
    })
  },
  /***************************渠道号管理****************************** */
  // 请求渠道号列表
  getNumberList(params) {
    return ajax({
      url: '/channel/list',
      type: 'get',
      params: params
    })
  },
  // 删除渠道号
  delNumberList(params) {
    return ajax({
      url: '/channel/delete',
      type: 'delete',
      params: params
    })
  },
  // 请求渠道成本列表
  getChannelCostList(params) {
    return ajax({
      url: '/channel/channelCost/list',
      type: 'get',
      params: params
    })
  },
  // 请求渠道成本列表
  updateChannelCost(params) {
    return ajax({
      url: '/channel/channelCost/update',
      type: 'post',
      params: params
    })
  },
  // 新增渠道号
  addNumber(params) {
    return ajax({
      url: '/channel/add',
      type: 'post',
      params: params
    })
  },
  // 编辑渠道号
  updateNumber(params) {
    return ajax({
      url: '/channel/update',
      type: 'post',
      params: params
    })
  },
  /***************************渠道商管理****************************** */
  // 请求渠道商列表
  getAgentList(params) {
    return ajax({
      url: '/channel/channelAgent/list',
      type: 'get',
      params: params
    })
  },
  // 新增渠道商
  addAgent(params) {
    return ajax({
      url: '/channel/channelAgent/add',
      type: 'post',
      params: params
    })
  },
  // 编辑渠道商
  updateAgent(params) {
    return ajax({
      url: '/channel/channelAgent/update',
      type: 'post',
      params: params
    })
  },
  // 删除渠道商
  delAgent(params) {
    return ajax({
      url: '/channel/channelAgent/delete',
      type: 'delete',
      params: params
    })
  },
  /***************************渠道页面配置****************************** */
  // 渠道页面配置列表
  getChannelConfigList(params) {
    return ajax({
      url: '/channel/channelPage/list',
      type: 'get',
      params: params
    })
  },
  // 渠道页面修改
  updateChannelConfig(params) {
    return ajax({
      url: '/channel/channelPage/update',
      type: 'post',
      params: params
    })
  },
  /***************************渠道页面配置****************************** */
  // 渠道成本修改记录
  getChannelUpdateList(params) {
    return ajax({
      url: '/channel/changeRecord/list',
      type: 'get',
      params: params
    })
  }
}

export default channelApi
